export const SIMPLE_DOTS_BREAKPOINT = 5;

export const MIN_DOTS_SHOW = 3;

export const DOT_SIZES = {
    L: 9,
    M: 7,
    S: 5,
    XS: 3
};

/**
 * Each dots array have one core array, which consists of three dots.
 * Active dot should be on one of three positions in the core array.
 */
export const CORE_DOT_POSITIONS = {
    LEFT: -1,
    CENTER: 0,
    RIGHT: 1
};
